angular.module('dpw.services').factory('installMnaService', ['api', 'popupUtil', '$q', '$rootScope', 'popup', 'conversationTypes', function (api, popupUtil, $q, $rootScope, popup, conversationTypes) {
    return {
        showConversationPicker: showConversationPicker
    };

    function showConversationPicker(app) {
        getRecentConversations().then(function (allRecentConversations) {
            var newScope = $rootScope.$new();

            newScope.config = {
                app: app,
                allRecentConversations: allRecentConversations,
                onClose: function () {
                    newScope.$destroy();
                }
            };

            popup({
                scope: newScope,
                directiveName: 'dpw-select-conversation',
                showHeader: false,
                showCloseBtn: false,
                extraClass: 'dpw-select-conversation-popup'
            });
        });
    }

    function getRecentConversations() {
        return $q(function (resolve, reject) {
            api.call(api.myAccount.glip.getRecentChats(), function (data) {
                var meChat = {
                    id: _.get(data, 'meInfo.groupId'),
                    type: conversationTypes.PERSONAL,
                    name: [
                        _.get(data, 'meInfo.firstName', ''), 
                        _.get(data, 'meInfo.lastName', ''),
                        '(me)'
                    ].join(' '),
                };
    
                var recentTeams = _.get(data, 'recentTeams', []);
                var results = [meChat].concat(recentTeams);

                resolve(results);
            }, function (err, defaultErrorHandler) {
                var code = _.get(err, 'status.message');
    
                if (code === 'NO_GLIP_COMPANY') {
                    popupUtil.ok({
                        title: RCDPW.Lang.SORRY,
                        content: RCDPW.Lang.MyAccount.NO_GLIP_COMPANY
                    });
                } else {
                    defaultErrorHandler();
                }

                reject();
            });
        });
    }


}]);
